module.exports = __webpack_public_path__ + "static/media/pubdev.15f5e99f.png";